export default __webpack_public_path__ + "static/media/card-cvc.93ba88e4.png";